import React, { FC } from 'react';
import { ModalBody, ModalCloseBtn, ModalHeader, useModalContext } from '@fiverr-private/overlay';
import { Stack } from '@fiverr-private/layout_components';
import { Heading, Text } from '@fiverr-private/typography';
import { Button } from '@fiverr-private/button';
import { I18n } from '@fiverr-private/i18n-react';
import { SUCCESS_STEP_TRANSLATION_KEY } from '../constants';
import { ISuccessStep } from './types';

export const SuccessStep: FC<ISuccessStep> = ({ adminInfo }) => {
    const { close } = useModalContext();

    return (
        <>
            <ModalHeader>
                <ModalCloseBtn />
            </ModalHeader>
            <ModalBody>
                <Stack alignItems="center" direction="column" gap="0">
                    <Heading as="h4">
                        <I18n k={`${SUCCESS_STEP_TRANSLATION_KEY}.title`} />
                    </Heading>
                    <Text marginTop="3" color="bodySecondary">
                        <I18n k={`${SUCCESS_STEP_TRANSLATION_KEY}.description`} />
                    </Text>
                    <Text fontWeight="bold" color="bodySecondary">
                        {adminInfo?.email}
                    </Text>
                    <Button marginTop="8" onClick={close}>
                        <I18n k={`${SUCCESS_STEP_TRANSLATION_KEY}.submit`} />
                    </Button>
                </Stack>
            </ModalBody>
        </>
    );
};
